import { render } from "./SingleValueTextBoxWithFallback.vue?vue&type=template&id=50ff9e78"
import script from "./SingleValueTextBoxWithFallback.vue?vue&type=script&lang=js"
export * from "./SingleValueTextBoxWithFallback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__